const PurchasesConstants = {
  GET_PURCHASES: 'GET_PURCHASES',
  GET_PURCHASES_SUCCESS: 'GET_PURCHASES_SUCCESS',
  GET_PURCHASES_FAILURE: 'GET_PURCHASES_FAILURE',
  ADD_PURCHASE: 'ADD_PURCHASE',
  ADD_PURCHASE_SUCCESS: 'ADD_PURCHASE_SUCCESS',
  ADD_PURCHASE_FAILURE: 'ADD_PURCHASE_FAILURE',
  DELETE_PURCHASE: 'DELETE_PURCHASE',
  DELETE_PURCHASE_SUCCESS: 'DELETE_PURCHASE_SUCCESS',
  DELETE_PURCHASE_FAILURE: 'DELETE_PURCHASE_FAILURE',
}

export default PurchasesConstants;